import { createAction } from '../../../../store.model';
import { FilterOptions } from '../model/filter-options.model';
import { ActionType } from '../task-list-dialog.action';

export interface FilterItems {
    opts?: FilterOptions;
}

export const filterItems = createAction<ActionType, FilterItems>(
    ActionType.TC__TL__FILTER_ITEMS,
);
